import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
import { images } from '../data/images';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" aria-labelledby="hero-title" className="relative flex h-[110vh] max-h-none min-h-[640px] items-center overflow-visible bg-ink" data-id="element-177" data-mp="9lv0spiridvb">
      <img src={images.hero} alt={t.hero.imageAlt} fetchPriority="high" className="absolute h-full w-full object-cover object-[50%_85%]" data-id="element-178" data-mp="1297ahz3tqr77" />
      <div aria-hidden="true" className="absolute inset-0 bg-violet-deep/5" data-id="element-179" data-mp="x8jmznet0shq" />
      <div aria-hidden="true" className="absolute inset-0 bg-ink/20" data-id="element-180" data-mp="s9ggrzn38g86" />

      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="relative mx-auto w-full max-w-7xl px-6 pb-16 md:px-10 md:pb-24" data-id="element-181" data-mp="nb6lzq59zhn3">
        <p className="font-serif text-[18px] italic text-white/90 md:text-[20px]" data-id="element-182" data-mp="3j8iyd2s0imwa">
          {t.hero.tagline}
        </p>
        <h1 id="hero-title" className="mt-4 max-w-3xl font-display text-[38px] font-medium leading-[1.12] tracking-[-0.015em] text-white md:text-[56px]" data-id="element-183" data-mp="3o85bzdbr655m">
          {t.hero.h1}
          <span className="sr-only" data-id="element-184" data-mp="3e8mtl1bhqrfo"> | Alma Yoga NYC</span>
        </h1>
        <p className="mt-6 text-[17px] font-medium tracking-[0.02em] text-white md:text-[19px]" data-id="element-185" data-mp="30i17l3qqq1dk">
          {t.hero.sub}
        </p>
        <p className="mt-4 max-w-xl text-[16px] leading-[1.8] text-white/85 md:text-[17px]" data-id="element-186" data-mp="358zpg7rdn7ix">
          {t.hero.description}
        </p>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4" data-id="element-187" data-mp="2qloh0eqhs3n1">
          <a href="#contact" className="btn btn-primary" data-id="element-188" data-mp="2vjg5szvub9n0">
            {t.hero.cta}
          </a>
          <a href="#services" className="btn btn-ghost-light" data-id="element-189" data-mp="2hjoyfhztwrhz">
            {t.hero.secondary}
          </a>
        </div>
      </motion.div>
    </section>;
}